import { render, staticRenderFns } from "./KbankAuto.vue?vue&type=template&id=169abb60&"
import script from "./KbankAuto.vue?vue&type=script&lang=js&"
export * from "./KbankAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports